import {
  DialogActions,
  DialogContent,
  FormControl,
  FormControlLabel,
  FormGroup,
  Radio,
  RadioGroup,
} from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useQuery } from "@tanstack/react-query";
import dayjs from "dayjs";
import * as React from "react";
import { getDoctors } from "../../api/doctors";
import { getOnDutyFrequency } from "../../api/schedules";
import { SCHEDULE_TYPE } from "../../const/enums";
import { RegularButton } from "../Button";

export default function DoctorSelector(props) {
  const { onClose, open, date, select, userId, doctor_id_excludes } = props;
  const [radioValue, setRadioValue] = React.useState(userId);

  const handleClose = () => {
    onClose();
  };
  const handleSelect = () => {
    select(radioValue);
    onClose();
  };

  const year = date ? dayjs(date).format("YYYY") : null;
  const month = date ? dayjs(date).format("MM") : null;
  const { data: freq, isSuccess: freqIsSuccess } = useQuery({
    queryKey: ["onDutyFrequency", year, month],
    queryFn: () => getOnDutyFrequency(year, month),
  });

  let freqMap = null;
  if (freqIsSuccess && freq?.freq) {
    freqMap = Map.groupBy(freq.freq, (e) => e.user_id);
  }
  const getFrequency = (lst, schedule_type_id) => {
    if (!lst) return 0;

    for (const elm of lst) {
      if (elm.schedule_type_id === schedule_type_id) {
        return elm.count;
      }
    }
    return 0;
  };

  const { data } = useQuery({
    queryKey: ["doctors"],
    queryFn: () => getDoctors(),
    throwOnError: true,
  });

  const handleChange = (e) => {
    setRadioValue(e.target.value);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        component: "form",
      }}
    >
      <DialogTitle>医師選択</DialogTitle>
      <FormControl>
        <FormGroup>
          <DialogContent sx={{ width: "600px" }}>
            <RadioGroup
              name="user_id"
              value={radioValue}
              defaultValue={radioValue}
              onChange={handleChange}
            >
              <TableContainer sx={{ maxHeight: 600 }}>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell>氏名</TableCell>
                      <TableCell>区分</TableCell>
                      <TableCell>当直</TableCell>
                      <TableCell>オンコール</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data?.map(
                      (d) =>
                        doctor_id_excludes.indexOf(d.id) === -1 && (
                          <TableRow key={d.id}>
                            <TableCell>
                              <FormControlLabel
                                value={d.user.id}
                                control={<Radio size="small" />}
                                label={d.full_name}
                              />
                            </TableCell>
                            <TableCell>
                              {d.doctor_type_name +
                                (d.doctor_type === 1 && d.is_first_year
                                  ? "(1年目)"
                                  : "")}
                            </TableCell>
                            <TableCell>
                              {freqMap &&
                                getFrequency(
                                  freqMap.get(d.user.id - 0),
                                  SCHEDULE_TYPE.ON_DUTY,
                                )}
                              回
                            </TableCell>
                            <TableCell>
                              {freqMap &&
                                getFrequency(
                                  freqMap.get(d.user.id - 0),
                                  SCHEDULE_TYPE.ON_CALL,
                                )}
                              回
                            </TableCell>
                          </TableRow>
                        ),
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </RadioGroup>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>キャンセル</Button>
            <RegularButton
              type="button"
              variant="contained"
              color="primary"
              size="medium"
              sx={{}}
              onClick={() => handleSelect()}
            >
              選択
            </RegularButton>
          </DialogActions>
        </FormGroup>
      </FormControl>
    </Dialog>
  );
}
